import React from "react";
import * as Icons from "lucide-react";
import { ADVANTAGES } from "@/lib/content";

export default function Advantages() {
  return (
    <section
      id="vorteile"
      data-testid="advantages-section"
      className="relative bg-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <p className="tag-line text-xs font-mono-tech uppercase tracking-[0.25em] text-slate-500 mb-6">
            Ihre Vorteile
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-slate-900 tracking-tight">
            Eine Komplettlösung,{" "}
            <span className="text-[#0055A4]">die sich messen lässt.</span>
          </h2>
          <p className="mt-6 text-slate-600 text-base sm:text-lg leading-relaxed">
            Weniger Schnittstellen, klarere Verantwortung, schnellere
            Inbetriebnahme – Xortec liefert messbare Vorteile in jeder
            Projektphase.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200 rounded-xl overflow-hidden">
          {ADVANTAGES.map((a, i) => {
            const Icon = Icons[a.icon] || Icons.Sparkles;
            return (
              <div
                key={a.title}
                data-testid={`advantage-${i}`}
                className="group bg-white p-6 hover:bg-slate-50 transition-colors flex flex-col h-full"
              >
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-[#0055A4]/10 text-[#0055A4] group-hover:bg-[#0055A4] group-hover:text-white transition-colors mb-5">
                  <Icon className="h-5 w-5" />
                </span>
                <h3 className="font-display font-medium text-base text-slate-900">
                  {a.title}
                </h3>
                <p className="mt-2 text-slate-600 text-xs leading-relaxed">
                  {a.text}
                </p>
                <div className="mt-auto pt-5 font-mono-tech text-[10px] text-slate-400 tracking-widest">
                  {String(i + 1).padStart(2, "0")} / {ADVANTAGES.length}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
